import * as React from 'react';
import Navbar from './nav/Navbar';
import Footer from '../main/nav/Footer';
import Chart from "react-apexcharts";
import axios from 'axios';
import { isMobile } from 'react-device-detect';

const chartColors = ['#0b7a5f', '#fdcb2c', '#2563eb', '#ef4444', '#8b5cf6', '#14b8a6'];

function SelectField({ label, value, onChange, children }) {
    return (
        <label className="block">
            <span className="mb-2 block text-xs font-extrabold uppercase tracking-normal text-slate-500">{label}</span>
            <select
                value={value || ''}
                onChange={onChange}
                className="h-12 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm font-bold text-brand-navy outline-none transition focus:border-brand-green focus:ring-2 focus:ring-brand-green/20"
            >
                {children}
            </select>
        </label>
    );
}

export default function GrafikJurnal({ auth }) {
    const [state, setState] = React.useState(false);
    const [series, setSeries] = React.useState([]);
    const [option, setOption] = React.useState({});
    const [tahun, setTahun] = React.useState([]);
    const [fakultas, setFakultas] = React.useState([]);
    const [prodi, setProdi] = React.useState([]);
    const [prodiValue, setProdiValue] = React.useState("");
    const [fakultasValue, setFakultasValue] = React.useState("");
    const [jenis, setJenis] = React.useState("");
    const [tahunValue, setTahunValue] = React.useState("");
    const [jenisPublikasi, setJenisPublikasi] = React.useState([]);
    const chartTotal = series.reduce((total, item) => total + item.data.reduce((sum, value) => sum + Number(value || 0), 0), 0);
    const [chartSubtitle, setChartSubtitle] = React.useState("Semua publikasi jurnal");

    const createBarOptions = (categories, title, stacked = false) => ({
        chart: {
            type: 'bar',
            stacked,
            fontFamily: 'Inter, sans-serif',
            foreColor: '#526070',
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 650,
            },
        },
        colors: ['#0284c7', '#0d9488', '#ea580c', '#e11d48', '#7c3aed', '#db2777', '#0891b2', '#65a30d'],
        plotOptions: {
            bar: {
                borderRadius: 3,
                borderRadiusApplication: 'end',
                columnWidth: '55%',
                dataLabels: {
                    position: 'top',
                }
            },
        },
        dataLabels: {
            enabled: true,
            offsetY: -22,
            style: {
                fontSize: '13px',
                colors: ['#475569'],
                fontFamily: 'Inter, sans-serif',
                fontWeight: 800
            },
            formatter: function (val) {
                return val > 0 ? val : "";
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.4,
                inverseColors: false,
                opacityFrom: 0.95,
                opacityTo: 0.85,
                stops: [0, 100]
            }
        },
        grid: {
            borderColor: '#f1f5f9',
            strokeDashArray: 5,
            xaxis: {
                lines: { show: false }
            },
            yaxis: {
                lines: { show: true }
            },
            padding: {
                top: 0,
                right: 10,
                bottom: 0,
                left: 10
            },
        },
        title: {
            text: title,
            style: {
                color: '#001525',
                fontSize: '15px',
                fontWeight: 800,
            }
        },
        xaxis: {
            categories: categories,
            labels: {
                style: {
                    colors: '#64748b',
                    fontWeight: 600
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            title: {
                text: 'Jumlah Publikasi',
                style: {
                    fontWeight: 700,
                    color: '#475569'
                }
            },
            labels: {
                style: { colors: '#64748b' }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: 'vertical',
                shadeIntensity: 0.25,
                inverseColors: false,
                opacityFrom: 0.9,
                opacityTo: 1,
                stops: [0, 100]
            }
        },
        tooltip: {
            theme: 'light',
            y: {
                formatter: function (val) {
                    return val + " publikasi"
                }
            },
            style: {
                fontSize: '13px',
                fontFamily: 'Inter, sans-serif'
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
            fontWeight: 700,
            markers: {
                radius: 8,
            },
        },
        tooltip: {
            theme: 'light',
            y: {
                formatter: function (val) {
                    return `${val} publikasi`
                }
            }
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    plotOptions: {
                        bar: {
                            columnWidth: '62%',
                        }
                    },
                    legend: {
                        position: 'bottom',
                    }
                }
            }
        ],
        noData: {
            text: 'Data grafik belum tersedia',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: '#6b7280',
                fontSize: '14px',
            }
        }
    });

    const onChangeFakultas = (value) => {
        setFakultasValue(value);
        fetchData(value, prodiValue, jenis);
    };

    const onChangeProdi = (value) => {
        setProdiValue(value);
        fetchData(fakultasValue, value, jenis);
    };

    const onChangeJenis = (item) => {
        setJenis(item.id);
        setChartSubtitle(item.nama);
        fetchData(fakultasValue, prodiValue, item.id);
    };

    const fetchJenisPublikasi = async () => {
        const { data } = await axios.get('/jenis-publikasi');
        if (data) {
            setJenisPublikasi(data);
        }
    };

    const fetchTahun = async () => {
        const { data } = await axios.get('/tahun');
        if (data) {
            setTahunValue(data[0]);
            setTahun(data);
        }
    };
    const fetchFakultas = async () => {
        const { data } = await axios.get('/fakultas');
        if (data) {
            setFakultas(data);
        }
    };
    const fetchProdi = async (fakultasValue) => {
        const { data } = await axios.get('/prodi/' + fakultasValue);
        if (data) {
            setProdi(data);
        }
    };
    React.useEffect(() => {
        fetchFakultas();
        fetchJenisPublikasi();
    }, [])
    React.useEffect(() => {
        if (fakultasValue) {
            fetchProdi(fakultasValue);
        }
    }, [fakultasValue])

    const fetchData = async (f_val = fakultasValue, p_val = prodiValue, j_val = jenis) => {
        try {
            const { data } = await axios.get('/grafikJurnal', {
                params: {
                    tahun: tahunValue,
                    fakultas: f_val,
                    prodi: p_val,
                    jenis: j_val
                }
            });

            if (data) {
                setSeries(data.series);
                const currentState = data.state;

                let title = 'Statistik Publikasi';
                if (currentState === 'fakultas') title = 'Perbandingan Publikasi per Fakultas';
                else if (currentState === 'prodi') title = 'Perbandingan Publikasi per Prodi';
                else if (currentState === 'jenis') title = 'Perbandingan Publikasi per Jenis Publikasi';

                setOption(createBarOptions(data.categories, title, currentState === 'fakultas'));
                setState(currentState);
            }
        } catch (error) {
            console.error("Gagal mengambil data grafik:", error);
        }
    };

    React.useEffect(() => {
        if (tahunValue) {
            fetchData(fakultasValue, prodiValue, jenis);
        }
    }, [tahunValue]);

    React.useEffect(() => {
        fetchTahun();
    }, []);

    return (
        <div className={auth ? "min-h-screen bg-slate-50 text-brand-navy" : "text-brand-navy"}>
            {auth ? <Navbar title={'Statistik'} /> : null}

            <main className={auth ? "min-h-screen overflow-auto px-4 pb-10 pt-24 sm:px-6 lg:px-8" : ""}>
                <div className={auth ? "mx-auto max-w-6xl" : ""}>
                    <section className="rounded-lg border border-slate-200 bg-gradient-to-b from-white to-slate-50 p-4 shadow-soft sm:p-6">
                        <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
                            <div>
                                <span className="text-xs font-extrabold uppercase tracking-normal text-brand-green">Statistik Repository</span>
                                <h3 className="mt-2 font-display text-2xl font-extrabold text-brand-navy sm:text-3xl">Grafik Publikasi Jurnal</h3>
                                <p className="mt-2 text-sm leading-6 text-slate-600">{chartSubtitle}</p>
                            </div>
                            <div className="rounded-lg bg-brand-navy p-4 text-white lg:min-w-44">
                                <span className="block text-xs font-bold text-slate-300">Total pada grafik</span>
                                <strong className="mt-2 block text-4xl font-extrabold leading-none">{chartTotal}</strong>
                                <small className="mt-2 block text-xs font-bold text-slate-300">{tahunValue ? `Tahun acuan ${tahunValue}` : 'Memuat tahun'}</small>
                            </div>
                        </div>

                        <div className="mt-6 grid gap-3 rounded-lg border border-slate-200 bg-slate-100 p-4 sm:grid-cols-2 lg:grid-cols-4">
                            <SelectField label="Tahun" value={tahunValue} onChange={(e) => setTahunValue(e.target.value)}>
                                {tahun.map((item) => (
                                    <option value={item} key={item + '_tahun'}>{item}</option>
                                ))}
                            </SelectField>

                            <SelectField label="Fakultas" value={fakultasValue} onChange={(e) => onChangeFakultas(e.target.value)}>
                                <option value="semua">Semua</option>
                                {fakultas?.map((item) => (
                                    <option value={item.id_unit} key={item.id_unit + '_fakultas'}>{item.nama_unit}</option>
                                ))}
                            </SelectField>

                            <SelectField label="Prodi" value={prodiValue} onChange={(e) => onChangeProdi(e.target.value)}>
                                <option value="">Semua</option>
                                {prodi.map((item) => (
                                    <option value={item.id_unit} key={item.id_unit + '_prodi'}>{item.nama_unit}</option>
                                ))}
                            </SelectField>

                            <SelectField
                                label="Jenis Publikasi"
                                value={jenis}
                                onChange={(e) => {
                                    const selected = jenisPublikasi.find(
                                        item => item.id === Number(e.target.value)
                                    );

                                    onChangeJenis(selected);
                                }}
                            >
                                <option value="">Semua</option>

                                {jenisPublikasi.map((item) => (
                                    <option value={item.id} key={item.id + '_jenis'}>
                                        {item.nama}
                                    </option>
                                ))}
                            </SelectField>
                        </div>

                        <div className="my-5 h-px bg-slate-200" />

                        {state ? (
                            <div className="rounded-xl border border-slate-100 bg-white px-2 py-4 shadow-xl shadow-slate-200/40 sm:px-4 sm:pt-6">
                                <Chart
                                    options={option}
                                    series={series}
                                    type="bar"
                                    height={isMobile ? 360 : 450}
                                />
                            </div>
                        ) : null}

                        <div className="mt-4 text-center text-sm text-slate-500">
                            Grafik menampilkan publikasi jurnal berdasarkan tahun, fakultas, prodi, atau jenis Publikasi.
                        </div>
                    </section>

                    {auth ? <Footer /> : null}
                </div>
            </main>
        </div>
    );
}
